import { createAction } from 'redux-actions';

export const getSSOToken = createAction('GET_SSO_TOKEN', (payload) => payload, (payload, metadata) => metadata);
export const getSSOTokenSuccess = createAction('GET_SSO_TOKEN_SUCCESS');
export const getSSOTokenFailure = createAction('GET_SSO_TOKEN_FAILURE');
